package space.stanton.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.pt
import org.jetbrains.compose.web.dom.Text
import space.stanton.components.utils.dateOf
import space.stanton.components.widgets.BlogItemStyle
import space.stanton.generated.BlogIndex
import space.stanton.generated.BlogPostInfo

@Composable
fun BlogPostList() {
    Column(
        Modifier
            .padding(3.cssRem)
            .fillMaxWidth(70.percent),
    ) {
        Box(
            Modifier
                .padding(bottom = 1.cssRem)
                .fontSize(25.pt)
        ) {
            Text("Recent posts:")
        }
        val context = rememberPageContext()
        BlogIndex.posts.map {
            BlogPostListItem(it) { route ->
                context.router.navigateTo(route)
            }
        }
    }
}


@Composable
fun BlogPostListItem(data: BlogPostInfo, onSelect: (String) -> Unit) {
    Row(
        BlogItemStyle.toModifier()
            .fillMaxWidth()
            .padding(1.cssRem)
            .height(4.cssRem)
            .onClick {
                onSelect(data.route)
            },
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Row {
            Text(data.title)
        }
        Row {
            Text(dateOf(data.date))
        }
    }
}